// Metadata for all manual-entry fields on the Integrated Dashboard.
// Used by the EditModal to render inputs, and to write into the dashboard sections.

// Each entry: { section_key, label, period, fields: [{ key, label, type }] }
// type: 'number' | 'text' | 'date' | 'boolean'

export const MANUAL_SECTIONS = {

  // ── Section 1. Population ─────────────────────────────────────────
  sec1_population: {
    title: 'Population (Static Data)',
    period: 'latest',
    fields: [
      { key: 'total_nos',      label: 'Total — in Nos',      type: 'number' },
      { key: 'total_pct',      label: 'Total — in %',        type: 'number' },
      { key: 'general_nos',    label: 'General — in Nos',    type: 'number' },
      { key: 'general_pct',    label: 'General — in %',      type: 'number' },
      { key: 'sc_nos',         label: 'SC — in Nos',         type: 'number' },
      { key: 'sc_pct',         label: 'SC — in %',           type: 'number' },
      { key: 'st_nos',         label: 'ST — in Nos',         type: 'number' },
      { key: 'st_pct',         label: 'ST — in %',           type: 'number' },
      { key: 'st_sea_nos',     label: 'ST (Socio-Economic Assessment) — Nos', type: 'number' },
      { key: 'st_sea_pct',     label: 'ST (Socio-Economic Assessment) — %',   type: 'number' },
    ],
  },

  // ── Section 2. Literacy rate ──────────────────────────────────────
  sec2_literacy: {
    title: 'Literacy Rate (%)',
    period: 'latest',
    fields: [
      { key: 'general_male',   label: 'General — Male %',    type: 'number' },
      { key: 'general_female', label: 'General — Female %',  type: 'number' },
      { key: 'general_total',  label: 'General — Total %',   type: 'number' },
      { key: 'sc_male',        label: 'SC — Male %',         type: 'number' },
      { key: 'sc_female',      label: 'SC — Female %',       type: 'number' },
      { key: 'sc_total',       label: 'SC — Total %',        type: 'number' },
      { key: 'st_male',        label: 'ST — Male %',         type: 'number' },
      { key: 'st_female',      label: 'ST — Female %',       type: 'number' },
      { key: 'st_total',       label: 'ST — Total %',        type: 'number' },
    ],
  },

  // ── Section 3. Drop-out ratio ─────────────────────────────────────
  sec3_dropout: {
    title: 'Drop-out Ratio (ADW & TW Schools)',
    period: '2025-26',
    fields: [
      { key: 'total_boys',   label: 'Total — Boys',   type: 'number' },
      { key: 'total_girls',  label: 'Total — Girls',  type: 'number' },
      { key: 'total_total',  label: 'Total — Total',  type: 'number' },
      { key: 'adw_boys',     label: 'ADW Schools — Boys',  type: 'number' },
      { key: 'adw_girls',    label: 'ADW Schools — Girls', type: 'number' },
      { key: 'adw_total',    label: 'ADW Schools — Total', type: 'number' },
      { key: 'tw_boys',      label: 'TW Schools — Boys',  type: 'number' },
      { key: 'tw_girls',     label: 'TW Schools — Girls', type: 'number' },
      { key: 'tw_total',     label: 'TW Schools — Total', type: 'number' },
    ],
  },

  // ── Section 4. School Admission (ADW) ─────────────────────────────
  sec4_school_adw: {
    title: 'School Admission (ADW)',
    period: '2026-27',
    fields: [
      { key: 'total_schools',     label: 'Total no of Schools',     type: 'number' },
      { key: 'boys_count',        label: 'Boys — in Nos',           type: 'number' },
      { key: 'boys_x_pct',        label: 'Boys — Class X Pass %',   type: 'number' },
      { key: 'boys_xii_pct',      label: 'Boys — Class XII Pass %', type: 'number' },
      { key: 'girls_count',       label: 'Girls — in Nos',          type: 'number' },
      { key: 'girls_x_pct',       label: 'Girls — Class X Pass %',  type: 'number' },
      { key: 'girls_xii_pct',     label: 'Girls — Class XII Pass %',type: 'number' },
      { key: 'total_count',       label: 'Total — in Nos',          type: 'number' },
      { key: 'total_x_pct',       label: 'Total — Class X Pass %',  type: 'number' },
      { key: 'total_xii_pct',     label: 'Total — Class XII Pass %',type: 'number' },
      { key: 't_gen_sanctioned',  label: 'Teachers Gen — Sanctioned',type: 'number' },
      { key: 't_gen_actual',      label: 'Teachers Gen — Actual',    type: 'number' },
      { key: 't_gen_vacant_pct',  label: 'Teachers Gen — Vacant %',  type: 'number' },
      { key: 't_sc_sanctioned',   label: 'Teachers SC — Sanctioned', type: 'number' },
      { key: 't_sc_actual',       label: 'Teachers SC — Actual',     type: 'number' },
      { key: 't_sc_vacant_pct',   label: 'Teachers SC — Vacant %',   type: 'number' },
      { key: 't_st_sanctioned',   label: 'Teachers ST — Sanctioned', type: 'number' },
      { key: 't_st_actual',       label: 'Teachers ST — Actual',     type: 'number' },
      { key: 't_st_vacant_pct',   label: 'Teachers ST — Vacant %',   type: 'number' },
    ],
  },

  // ── Section 4(a). School Admission (TW) ───────────────────────────
  sec4a_school_tw: {
    title: 'School Admission (TW)',
    period: '2026-27',
    fields: [
      { key: 'total_schools',     label: 'Total no of Schools',     type: 'number' },
      { key: 'boys_count',        label: 'Boys — in Nos',           type: 'number' },
      { key: 'boys_x_pct',        label: 'Boys — Class X Pass %',   type: 'number' },
      { key: 'boys_xii_pct',      label: 'Boys — Class XII Pass %', type: 'number' },
      { key: 'girls_count',       label: 'Girls — in Nos',          type: 'number' },
      { key: 'girls_x_pct',       label: 'Girls — Class X Pass %',  type: 'number' },
      { key: 'girls_xii_pct',     label: 'Girls — Class XII Pass %',type: 'number' },
      { key: 'total_count',       label: 'Total — in Nos',          type: 'number' },
      { key: 'total_x_pct',       label: 'Total — Class X Pass %',  type: 'number' },
      { key: 'total_xii_pct',     label: 'Total — Class XII Pass %',type: 'number' },
      { key: 't_gen_sanctioned',  label: 'Teachers Gen — Sanctioned',type: 'number' },
      { key: 't_gen_actual',      label: 'Teachers Gen — Actual',    type: 'number' },
      { key: 't_gen_vacant_pct',  label: 'Teachers Gen — Vacant %',  type: 'number' },
      { key: 't_sc_sanctioned',   label: 'Teachers SC — Sanctioned', type: 'number' },
      { key: 't_sc_actual',       label: 'Teachers SC — Actual',     type: 'number' },
      { key: 't_sc_vacant_pct',   label: 'Teachers SC — Vacant %',   type: 'number' },
      { key: 't_st_sanctioned',   label: 'Teachers ST — Sanctioned', type: 'number' },
      { key: 't_st_actual',       label: 'Teachers ST — Actual',     type: 'number' },
      { key: 't_st_vacant_pct',   label: 'Teachers ST — Vacant %',   type: 'number' },
    ],
  },

  // ── Section 5. Hostel — ADW ───────────────────────────────────────
  sec5_hostel_adw: {
    title: 'Hostel — ADW',
    period: 'latest',
    fields: [
      // Students
      { key: 'total_hostels',     label: 'Total no of Hostels',    type: 'number' },
      { key: 'boys_sanctioned',   label: 'Boys — Sanctioned',      type: 'number' },
      { key: 'boys_actual',       label: 'Boys — Actual',          type: 'number' },
      { key: 'boys_vacant_pct',   label: 'Boys — Vacant %',        type: 'number' },
      { key: 'girls_sanctioned',  label: 'Girls — Sanctioned',     type: 'number' },
      { key: 'girls_actual',      label: 'Girls — Actual',         type: 'number' },
      { key: 'girls_vacant_pct',  label: 'Girls — Vacant %',       type: 'number' },
      // Wardens
      { key: 'w_gen_sanctioned',  label: 'Wardens Gen — Sanctioned', type: 'number' },
      { key: 'w_gen_actual',      label: 'Wardens Gen — Actual',     type: 'number' },
      { key: 'w_gen_vacant_pct',  label: 'Wardens Gen — Vacant %',   type: 'number' },
      { key: 'w_sc_sanctioned',   label: 'Wardens SC — Sanctioned',  type: 'number' },
      { key: 'w_sc_actual',       label: 'Wardens SC — Actual',      type: 'number' },
      { key: 'w_sc_vacant_pct',   label: 'Wardens SC — Vacant %',    type: 'number' },
      { key: 'w_st_sanctioned',   label: 'Wardens ST — Sanctioned',  type: 'number' },
      { key: 'w_st_actual',       label: 'Wardens ST — Actual',      type: 'number' },
      { key: 'w_st_vacant_pct',   label: 'Wardens ST — Vacant %',    type: 'number' },
      { key: 'w_total_sanctioned',label: 'Wardens Total — Sanctioned',type: 'number' },
      { key: 'w_total_actual',    label: 'Wardens Total — Actual',    type: 'number' },
      { key: 'w_total_vacant_pct',label: 'Wardens Total — Vacant %',  type: 'number' },
      // BioMetric
      { key: 'bio_avg_attend_pct',    label: 'BioMetric — Avg Daily Attendance %', type: 'number' },
      { key: 'bio_below_75_pct',      label: 'BioMetric — Students < 75% attendance', type: 'number' },
      { key: 'bio_bottom5',           label: 'BioMetric — Bottom-5 hostels (list)', type: 'text' },
      { key: 'bio_devices_broken_pct',label: 'BioMetric — Devices non-functional %', type: 'number' },
      { key: 'bio_alt_system',        label: 'BioMetric — Alternative attendance system', type: 'text' },
      // Food quality
      { key: 'food_quantity_adequate',label: 'Food — Quantity adequate for all?', type: 'text' },
      { key: 'food_norms',            label: 'Food — Veg/Egg/Non-Veg per norms?', type: 'text' },
      { key: 'food_water_source',     label: 'Food — Major drinking water source', type: 'text' },
      { key: 'food_complaints_6mo',   label: 'Food — Complaints in last 6 months?', type: 'text' },
      { key: 'food_complaints_resolved',label: 'Food — Complaints resolved?', type: 'text' },
      // Inspection
      { key: 'insp_scheduled',        label: 'Inspection — Scheduled (June 2026)', type: 'number' },
      { key: 'insp_conducted',        label: 'Inspection — Actually conducted',    type: 'number' },
      { key: 'insp_pending_pct',      label: 'Inspection — % Pending',             type: 'number' },
      { key: 'insp_reports_hod',      label: 'Inspection — Reports sent to HOD',   type: 'number' },
      { key: 'insp_critical_issues',  label: 'Inspection — Critical issues?',      type: 'text' },
    ],
  },

  // ── Section 5(a). Hostel — TW ─────────────────────────────────────
  sec5a_hostel_tw: {
    title: 'Hostel — TW',
    period: 'latest',
    fields: [
      { key: 'total_hostels',     label: 'Total no of Hostels',    type: 'number' },
      { key: 'boys_sanctioned',   label: 'Boys — Sanctioned',      type: 'number' },
      { key: 'boys_actual',       label: 'Boys — Actual',          type: 'number' },
      { key: 'boys_vacant_pct',   label: 'Boys — Vacant %',        type: 'number' },
      { key: 'girls_sanctioned',  label: 'Girls — Sanctioned',     type: 'number' },
      { key: 'girls_actual',      label: 'Girls — Actual',         type: 'number' },
      { key: 'girls_vacant_pct',  label: 'Girls — Vacant %',       type: 'number' },
      { key: 'w_gen_sanctioned',  label: 'Wardens Gen — Sanctioned', type: 'number' },
      { key: 'w_gen_actual',      label: 'Wardens Gen — Actual',     type: 'number' },
      { key: 'w_gen_vacant_pct',  label: 'Wardens Gen — Vacant %',   type: 'number' },
      { key: 'w_sc_sanctioned',   label: 'Wardens SC — Sanctioned',  type: 'number' },
      { key: 'w_sc_actual',       label: 'Wardens SC — Actual',      type: 'number' },
      { key: 'w_sc_vacant_pct',   label: 'Wardens SC — Vacant %',    type: 'number' },
      { key: 'w_st_sanctioned',   label: 'Wardens ST — Sanctioned',  type: 'number' },
      { key: 'w_st_actual',       label: 'Wardens ST — Actual',      type: 'number' },
      { key: 'w_st_vacant_pct',   label: 'Wardens ST — Vacant %',    type: 'number' },
      { key: 'w_total_sanctioned',label: 'Wardens Total — Sanctioned',type: 'number' },
      { key: 'w_total_actual',    label: 'Wardens Total — Actual',    type: 'number' },
      { key: 'w_total_vacant_pct',label: 'Wardens Total — Vacant %',  type: 'number' },
      { key: 'bio_avg_attend_pct',    label: 'BioMetric — Avg Daily Attendance %', type: 'number' },
      { key: 'bio_below_75_pct',      label: 'BioMetric — Students < 75% attendance', type: 'number' },
      { key: 'bio_bottom5',           label: 'BioMetric — Bottom-5 hostels (list)', type: 'text' },
      { key: 'bio_devices_broken_pct',label: 'BioMetric — Devices non-functional %', type: 'number' },
      { key: 'bio_alt_system',        label: 'BioMetric — Alternative attendance system', type: 'text' },
      { key: 'food_quantity_adequate',label: 'Food — Quantity adequate for all?', type: 'text' },
      { key: 'food_norms',            label: 'Food — Veg/Egg/Non-Veg per norms?', type: 'text' },
      { key: 'food_water_source',     label: 'Food — Major drinking water source', type: 'text' },
      { key: 'food_complaints_6mo',   label: 'Food — Complaints in last 6 months?', type: 'text' },
      { key: 'food_complaints_resolved',label: 'Food — Complaints resolved?', type: 'text' },
      { key: 'insp_scheduled',        label: 'Inspection — Scheduled (June 2026)', type: 'number' },
      { key: 'insp_conducted',        label: 'Inspection — Actually conducted',    type: 'number' },
      { key: 'insp_pending_pct',      label: 'Inspection — % Pending',             type: 'number' },
      { key: 'insp_reports_hod',      label: 'Inspection — Reports sent to HOD',   type: 'number' },
      { key: 'insp_critical_issues',  label: 'Inspection — Critical issues?',      type: 'text' },
    ],
  },

  // ── Section 6 (middle row). Free House Site Pattas — Manual Entry ─
  sec6_pattas_manual: {
    title: 'Free House Site Pattas — Pattas & Applications (Manual)',
    period: 'latest',
    fields: [
      { key: 'pattas_can_be_given',       label: 'Pattas Can be Given in Acquired Fields', type: 'number' },
      { key: 'pattas_given_beneficiaries',label: 'Patta Given (No. of Beneficiaries)',      type: 'number' },
      { key: 'vacant_plot',               label: 'Vacant Plot',                             type: 'number' },
      { key: 'total_applications',        label: 'Total Applications',                      type: 'number' },
      { key: 'eligible_not_given',        label: 'Eligible but Patta Not Given',            type: 'number' },
      { key: 'rejected_petitions',        label: 'Rejected Petitions',                      type: 'number' },
      { key: 'not_scrutinised',           label: 'Applications Not Scrutinised',            type: 'number' },
    ],
  },

  // ── Section 7. Court Cases ────────────────────────────────────────
  sec7_court_cases: {
    title: 'Court Cases',
    period: '2026',
    fields: [
      { key: 'pending',            label: 'Pending',                       type: 'number' },
      { key: 'new_since_2026',     label: 'New Cases (from 01.01.2026)',   type: 'number' },
      { key: 'more_than_1yr',      label: 'More than 1 Year Pending',      type: 'number' },
      { key: 'contempt',           label: 'Contempt Cases (if any)',       type: 'number' },
      { key: 'ca_not_filed',       label: 'No. of CA Not Filed',           type: 'number' },
    ],
  },

  // ── Section 8. CM Cell Petitions ──────────────────────────────────
  sec8_cm_cell: {
    title: 'CM Cell Petitions',
    period: '2026',
    fields: [
      { key: 'pending',   label: 'Total Pending',   type: 'number' },
      { key: 'new_cases', label: 'New Cases Received (from new govt took charge)', type: 'number' },
      { key: 'rating_a',  label: 'Current Petitions — Rating A', type: 'number' },
      { key: 'rating_b',  label: 'Current Petitions — Rating B', type: 'number' },
      { key: 'rating_c',  label: 'Current Petitions — Rating C', type: 'number' },
    ],
  },

  // ── Section 9. RTI ────────────────────────────────────────────────
  sec9_rti: {
    title: 'RTI',
    period: '2026',
    fields: [
      { key: 'received',          label: 'Total Application Received (from 01.01.2026)', type: 'number' },
      { key: 'disposed',          label: 'No. of Disposal Applications',                 type: 'number' },
      { key: 'pending',           label: 'Pending',                                      type: 'number' },
      { key: 'appeal1',           label: 'RTI 1st Appeal',                               type: 'number' },
      { key: 'appeal_commission', label: 'RTI Appeal (2nd level) — Commission',          type: 'number' },
    ],
  },

  // ── Section 10. Pending files at Government ───────────────────────
  sec10_pending_files: {
    title: 'Pending files at Government',
    period: 'latest',
    fields: [
      { key: 'total',    label: 'Total Pending',   type: 'number' },
      { key: 'more_1yr', label: 'More than 1 yr',  type: 'number' },
      { key: 'more_3yr', label: 'More than 3 yrs', type: 'number' },
      { key: 'more_5yr', label: 'More than 5 yrs', type: 'number' },
    ],
  },

  // ── Section 11.1 Burial grounds — SC ──────────────────────────────
  sec11_1_burial_sc: {
    title: 'Burial Grounds / Crematorium — SC',
    period: 'latest',
    fields: [
      { key: 'total_sc_hab',        label: 'Total SC Habitations',                             type: 'number' },
      { key: 'common_no_issues',    label: 'SC Habitations with Common Burial (no issues)',    type: 'number' },
      { key: 'dedicated',           label: 'SC Habitations with Dedicated Burial Grounds',     type: 'number' },
      { key: 'without_dedicated',   label: 'SC Habitations without Dedicated Burial',          type: 'number' },
      { key: 'without_pathways',    label: 'SC Habitations without Pathways',                  type: 'number' },
      { key: 'encroachments',       label: 'Encroachments on Land / Path',                     type: 'number' },
    ],
  },

  // ── Section 11.2 Burial grounds — ST ──────────────────────────────
  sec11_2_burial_st: {
    title: 'Burial Grounds / Crematorium — ST',
    period: 'latest',
    fields: [
      { key: 'total_st_hab',        label: 'Total ST Habitations',                             type: 'number' },
      { key: 'common_no_issues',    label: 'ST Habitations with Common Burial (no issues)',    type: 'number' },
      { key: 'dedicated',           label: 'ST Habitations with Dedicated Burial Grounds',     type: 'number' },
      { key: 'without_dedicated',   label: 'ST Habitations without Dedicated Burial',          type: 'number' },
      { key: 'without_pathways',    label: 'ST Habitations without Pathways',                  type: 'number' },
      { key: 'encroachments',       label: 'Encroachments on Land / Path',                     type: 'number' },
    ],
  },

  // ── Section 12. Transport / Water ─────────────────────────────────
  sec12_transport_water: {
    title: 'Transport Access / Water',
    period: 'latest',
    fields: [
      { key: 'no_public_transport', label: 'Habitations without Public Transport',   type: 'number' },
      { key: 'no_all_weather',      label: 'Habitations without All-Weather Roads',  type: 'number' },
      { key: 'no_drinking_water',   label: 'Habitations without Drinking Water',     type: 'number' },
      { key: 'no_mobile',           label: 'Habitations without Mobile Network',     type: 'number' },
      { key: 'no_electricity_hab',  label: 'Habitations without Electricity',        type: 'number' },
      { key: 'no_electricity_st_hh',label: 'ST Households without Electricity',      type: 'number' },
    ],
  },

  // ── Section 14. Buildings ─────────────────────────────────────────
  sec14_buildings: {
    title: 'Buildings (School / Hostel) — Age (nos)',
    period: 'latest',
    fields: [
      { key: 'y20_30',        label: 'Between 20–30 yrs',                        type: 'number' },
      { key: 'y30_40',        label: 'Between 30–40 yrs',                        type: 'number' },
      { key: 'y40_plus',      label: 'More than 40 yrs',                         type: 'number' },
      { key: 'stability_cert',label: 'Applied Stability Certificate?',           type: 'text'   },
    ],
  },

  // ── Section 17. DAPSC/ST ──────────────────────────────────────────
  sec17_dap: {
    title: 'DAPSC/ST — District Monitoring Committee',
    period: '2026',
    fields: [
      { key: 'dmc_formed', label: 'Was District Monitoring Committee formed?', type: 'text' },
      { key: 'q1',         label: 'DMC Q1 (Conducted / Not Conducted)',        type: 'text' },
      { key: 'q2',         label: 'DMC Q2 (Conducted / Not Conducted)',        type: 'text' },
      { key: 'q3',         label: 'DMC Q3 (Conducted / Not Conducted)',        type: 'text' },
      { key: 'q4',         label: 'DMC Q4 (Conducted / Not Conducted)',        type: 'text' },
    ],
  },

  // ── Section 18 (manual bits). Vigilance — atrocity + awareness ────
  sec18_vmc_manual: {
    title: 'Vigilance Monitoring — Manual entries',
    period: '2026',
    fields: [
      { key: 'atrocity_prone_reviewed', label: 'Atrocity-prone Villages Identified & Reviewed?', type: 'text' },
      { key: 'awareness_programmes',    label: 'Awareness Programmes in Vulnerable Villages?',   type: 'text' },
    ],
  },

  // ── Section 19. District ADW Committee ────────────────────────────
  sec19_dw_committee: {
    title: 'District Adi Dravidar Welfare Committee',
    period: '2025-26',
    fields: [
      { key: 'meetings_held',      label: 'Meetings held during last year?',           type: 'number' },
      { key: 'last_meeting_date',  label: 'When was the last meeting?',                type: 'date'   },
      { key: 'petitions_received', label: 'Petitions received during 2025-26',          type: 'number' },
      { key: 'petitions_unresolved',label: 'Petitions yet to be resolved during 2025-26', type: 'number' },
    ],
  },

  // ── Section 20. Cleanliness Committee ─────────────────────────────
  sec20_cleanliness: {
    title: 'Cleanliness Committee',
    period: 'latest',
    fields: [
      { key: 'meetings_held',      label: 'Meetings held during last year?',   type: 'number' },
      { key: 'last_meeting_date',  label: 'When was the last meeting?',        type: 'date'   },
      { key: 'members_2025_26',    label: 'Members enrolled in 2025-26',       type: 'number' },
      { key: 'members_2026_27',    label: 'Members enrolled in 2026-27',       type: 'number' },
    ],
  },

  // ── Section 21. Community Certificate ─────────────────────────────
  sec21_community_cert: {
    title: 'Community Certificate',
    period: 'latest',
    fields: [
      { key: 'total_pending',    label: 'How many applications are Pending?', type: 'number' },
      { key: 'pending_dsp',      label: 'Pending with DSP',                   type: 'number' },
      { key: 'pending_anthro',   label: 'Pending with Anthropology',          type: 'number' },
      { key: 'pending_rdo',      label: 'Pending with RDO',                   type: 'number' },
    ],
  },

  // ── Section 23. Loan Applications (per-scheme × 6 columns) ────────
  sec23_loan_applications: {
    title: 'Loan Applications (per Scheme)',
    period: '2025-26',
    fields: (() => {
      const schemes = [
        { code: 'cm_arise',    label: '(i) CM-Arise' },
        { code: 'pm_ajay',     label: 'PM-AJAY' },
        { code: 'land_nannilam',       label: '(ii) Land — Nannilam Magalir Nilaudamai Thittam' },
        { code: 'land_nannilam_own',   label: '(iii) Land — Nannilam Own Contribution' },
        { code: 'micro_credit',        label: '(iv) Micro Credit Finance' },
      ];
      const cols = [
        { suffix: 'received',   label: 'Received',   type: 'number' },
        { suffix: 'approved',   label: 'Approved',   type: 'number' },
        { suffix: 'pending',    label: 'Pending',    type: 'number' },
        { suffix: 'rejected',   label: 'Rejected',   type: 'number' },
        { suffix: 'allocation', label: 'Allocation FY 2025-26', type: 'number' },
        { suffix: 'unspent',    label: 'Unspent FY 2025-26',    type: 'number' },
      ];
      const out = [];
      schemes.forEach(s => cols.forEach(c => {
        out.push({ key: `${s.code}__${c.suffix}`, label: `${s.label} — ${c.label}`, type: c.type });
      }));
      return out;
    })(),
  },

  // ── Section 24. Construction Status (per-type × 5 columns) ────────
  sec24_construction: {
    title: 'Construction Status (per Module)',
    period: '2025-26',
    fields: (() => {
      const types = [
        { code: 'hostel',           label: '(i) Hostel' },
        { code: 'school',           label: '(ii) School' },
        { code: 'community_hall',   label: '(iii) Community Hall (VKC)' },
        { code: 'shopping_complex', label: '(iv) Shopping Complex' },
      ];
      const cols = [
        { suffix: 'sanctioned', label: 'Sanctioned 2025-26', type: 'number' },
        { suffix: 'completed',  label: 'Completed 2025-26',  type: 'number' },
        { suffix: 'under_const',label: 'Under Construction', type: 'number' },
        { suffix: 'not_started',label: 'Not Yet Started',    type: 'number' },
        { suffix: 'occupancy',  label: 'Occupied / Unoccupied', type: 'text' },
      ];
      const out = [];
      types.forEach(t => cols.forEach(c => {
        out.push({ key: `${t.code}__${c.suffix}`, label: `${t.label} — ${c.label}`, type: c.type });
      }));
      return out;
    })(),
  },

  // ── Section 25. FRA (from FRA Portal, but until integrated: manual)
  sec25_fra: {
    title: 'FRA — Forest Rights Act',
    period: 'latest',
    fields: [
      { key: 'claims_received',           label: 'Total Claims Received',                type: 'number' },
      { key: 'frc_completed',             label: 'FRC Verification Completed',           type: 'number' },
      { key: 'frc_pending',               label: 'FRC Verification Pending',             type: 'number' },
      { key: 'recommended_survey',        label: 'Claims Recommended for Survey',        type: 'number' },
      { key: 'pending_survey',            label: 'Claims Pending for Survey',            type: 'number' },
      { key: 'recommended_sdlc',          label: 'Claims Recommended to SDLC',           type: 'number' },
      { key: 'pending_resolution_sdclc',  label: 'Claims Pending for Resolution (to SDCL)', type: 'number' },
      { key: 'recommended_dlc',           label: 'Claims Recommended to DLC',            type: 'number' },
      { key: 'pending_sdlc',              label: 'Claims Pending with SDLC',             type: 'number' },
      { key: 'approved_dlc',              label: 'Claims Approved by DLC',               type: 'number' },
      { key: 'pending_dlc',               label: 'Claims Pending with DLC',              type: 'number' },
      { key: 'titles_issued',             label: 'Titles Issued',                        type: 'number' },
      { key: 'titles_pending',            label: 'Titles Pending',                       type: 'number' },
    ],
  },

  // ── Section 26. Other Issues ──────────────────────────────────────
  sec26_other: {
    title: 'Other Issues (New Schemes / Ideas / Immediate Actions)',
    period: 'latest',
    fields: [
      { key: 'notes', label: 'Notes', type: 'text' },
    ],
  },

};

// Small helper: lookup a value from an array of { section_key, field_key, period, value }
export const lookupValue = (entries, section_key, field_key, period = '') => {
  if (!Array.isArray(entries)) return null;
  const row = entries.find(e =>
    e.section_key === section_key &&
    e.field_key === field_key &&
    (e.period || '') === (period || '')
  );
  return row ? row.value : null;
};
